import eventBus from "@/app/app-event-bus.mjs";
import { devLog } from "@/util/dev.mjs";

export const EVENT_CSGO_ENTER_GAME = "EVENT_CSGO_ENTER_GAME";
export const EVENT_CSGO_EXIT_GAME = "EVENT_CSGO_EXIT_GAME";

eventBus.on(EVENT_CSGO_ENTER_GAME, () => {
  devLog("CSGO_START tracking event fired");
});
eventBus.on(EVENT_CSGO_EXIT_GAME, () => {
  devLog("CSGO_END tracking event fired");
});
